import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["search"]

  connect() {
    this.lastValue = this.searchTarget.value

    // Create a debounced version of the search function
    this.debouncedSearch = this.debounce(() => {
      // Only search if the value has actually changed
      if (this.lastValue !== this.searchTarget.value) {
        this.lastValue = this.searchTarget.value
        this.search()
      }
    }, 500) // 500ms delay
  }

  debounce(func, wait) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }

  search() {
    // Store cursor position and selection
    const cursorPosition = this.searchTarget.selectionStart
    const selectionLength = this.searchTarget.selectionEnd - this.searchTarget.selectionStart
    const value = this.searchTarget.value

    // Use Turbo.visit instead of form submission to maintain state
    const url = new URL(this.searchTarget.form.action)
    const formData = new FormData(this.searchTarget.form)
    url.search = new URLSearchParams(formData).toString()

    Turbo.visit(url.toString(), { action: "advance" })

    // After navigation, restore the input state
    document.addEventListener('turbo:load', () => {
      const searchInput = document.querySelector('[data-photos-search-target="search"]')
      if (searchInput) {
        searchInput.value = value
        searchInput.focus()
        searchInput.setSelectionRange(cursorPosition, cursorPosition + selectionLength)
      }
    }, { once: true })
  }

  clear() {
    this.searchTarget.value = ''
    this.search()
  }
} 